<template>
  <div class="xs-12 m-8">
    <div class="xs-12 main-tab" :class="{ 'main-tab__past-wish-events': waitingListSection || pastSection }">
      <div class="main-tab__heading">
        <h1 class="dea-heading--medium__l dea-text--left main-tab__heading-title" tabindex="0">
          {{ mainTitle }}
        </h1>
        <InputText
          v-if="false && pastSection"
          id="past-events"
          type="text"
          icon="ricerca"
          placeholder="cerca corso"
          @change="$emit('filter-past')"
        ></InputText>
      </div>
      <div v-if="waitingListSection" class="main-tab__subtitle dea-heading--regular__xm">{{ subtitle }}</div>
      <slot />
      <slot name="interest-courses" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputText from "@/components/elements/InputText";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MainTabEvents",
  components: {
    InputText,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    secondaryTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      classActive: false,
      subtitle:
        "Sei iscritto/a alla lista d'attesa di questi corsi. Riceverai un'email con le informazioni per iscriverti se un posto sarà disponibile. Tieni d'occhio la tua casella di posta per non perdere la tua occasione!",
    };
  },
  computed: {
    ...mapGetters(["user", "ticketFilter", "waitingListRegistrations"]),
    waitingListSection() {
      return this.ticketFilter === "waitingList" && this.waitingListRegistrations.length;
    },
    pastSection() {
      return this.ticketFilter === "past";
    },
  },
  watch: {
    mainTitle() {
      setFocus("main-tab__heading-title");
    },
  },
  mounted() {
    setFocus("main-tab__heading-title");
  },
  activated() {
    setFocus("main-tab__heading-title");
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.main-tab {
  &__button {
    display: flex;
    justify-content: flex-end;
  }

  &__authorization-box {
    margin-bottom: $space-x-large;
  }

  &__authorization-title {
    margin-bottom: $space-xx-small;
    text-transform: uppercase;
  }

  &__heading {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: $space-large;

    h2 {
      margin: 0;
    }
  }

  &__subtitle {
    margin-top: $space-x-small;
  }
}

.main-tab__authorization-box--small {
  margin-bottom: $space-small !important; //sass-lint:disable-line no-important

  span {
    cursor: pointer;
  }
}

.data-container {
  @include media("<=s") {
    margin-bottom: $space-base !important; //sass-lint:disable-line no-important
  }
  margin-bottom: $space-large !important; //sass-lint:disable-line no-important

  &__block {
    margin-bottom: $space-base;
  }

  &__info {
    display: inline-block;
    position: relative;
  }
}

.data-container--small {
  margin-bottom: $space-small !important; //sass-lint:disable-line no-important
}
</style>
